import {
    Box,
    Paper, Typography, useTheme,
    FormControl,
    Select,
    MenuItem,
    InputLabel,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { ptBR } from '@mui/x-data-grid/locales';
import clsx from 'clsx';
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAppThemeContext, useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, UtilidadeService, tipoConfronto } from "../../shered/services/api/utilidades/UtilidadesService";
import { IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";

import { EstatisticasService, IDadosMelhoresJogadoresPorPosicao, IDadosPontuacaoMelhoresJogadores, IListaDadosMediaTimes, IRetornoMelhoresJogadoresPorPosicao } from "../../shered/services/api/estatisticas/EstatisticasService";
import { DataGrid, GridCellParams, GridColDef } from "@mui/x-data-grid";
import { Loading } from "../../shered/components/loading/Loading";

const lstQtdRodadasFiltro = [
    {
        codigo: 5,
        label: "5"
    },
    {
        codigo: 10,
        label: "10"
    },
    {
        codigo: 15,
        label: "15"
    },
    {
        codigo: 20,
        label: "20"
    },
    {
        codigo: 25,
        label: "25"
    },
    {
        codigo: 30,
        label: "30"
    },
    {
        codigo: 35,
        label: "35"
    },
    {
        codigo: 40,
        label: "40"
    },
    {
        codigo: 45,
        label: "45"
    },
    {
        codigo: 50,
        label: "50"
    }
    ,
    {
        codigo: 100,
        label: "100"
    }
];

const columnsGeral: GridColDef[] = [
    {
        field: 'tipo_Premiacao',
        headerName: '',
        flex: 1,
        minWidth: 58,
        maxWidth: 58,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
    },
    {
        field: 'nome_Premiacao',
        headerName: 'PREMIAÇÃO',
        flex: 1,
        minWidth: 110,
        maxWidth: 120,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
        sortable: false,
    },
    {
        field: 'caminho_Logo_Franquia_Liga',
        headerName: 'LOGO',
        editable: false,
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 35 : 60,
        maxWidth: UtilidadeService.isMobile() ? 35 : 65,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => params.value !== null ? <img src={params.value} width={UtilidadeService.isMobile() ? 25 : 45} height={UtilidadeService.isMobile() ? 30 : 50} /> : null,
    },
    {
        field: 'nome_Franquia_Liga',
        headerName: 'LIGA',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 115 : 180,
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'foto',
        headerName: 'FOTO',
        editable: false,
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 40 : 60,
        maxWidth: UtilidadeService.isMobile() ? 40 : 65,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => params.value !== null ? <img src={params.value} width={UtilidadeService.isMobile() ? 30 : 50} height={UtilidadeService.isMobile() ? 30 : 45} /> : null,
    },
    {
        field: 'nome',
        headerName: 'JOGADOR',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 115 : 180,
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'logo_Franquia_NBA',
        headerName: 'LOGO',
        editable: false,
        flex: 1,
        minWidth: UtilidadeService.isMobile() ? 35 : 65,
        maxWidth: UtilidadeService.isMobile() ? 35 : 65,
        headerClassName: 'super-app-theme--header',
        renderCell: (params) => params.value !== null ? <img src={params.value} width={UtilidadeService.isMobile() ? 25 : 40} height={UtilidadeService.isMobile() ? 30 : 45} /> : null,
    },
    {
        field: 'nome_Franquia_NBA',
        headerName: 'NBA',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 115 : 180,
        headerClassName: 'super-app-theme--header'
    },
    {
        field: 'quantidade_Jogos',
        headerName: 'QTD',
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        editable: false,
        align: 'center',
        headerAlign: 'center'
    },
    {
        field: 'minutos',
        headerName: 'MIN',
        editable: false,
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: 60,
        maxWidth: 60,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'lance_Livre',
        headerName: 'FGM',
        editable: false,
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: 60,
        maxWidth: 60,
        headerClassName: 'super-app-theme--header',
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'tres_Pontos',
        headerName: '3PTS',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'pontos',
        headerName: 'PTS',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"


    },
    {
        field: 'rebotes',
        headerName: 'REB',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'rebotes_Ofensivos',
        headerName: 'OREB',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'rebotes_Defensivos',
        headerName: 'DREB',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'assistencias',
        headerName: 'AST',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'steal',
        headerName: 'STL',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        // cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'bloqueios',
        headerName: 'BLK',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'turnovers',
        headerName: 'TO',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'faltas',
        headerName: 'PF',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'min_Plus',
        headerName: 'MPLU',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        cellClassName: (params: GridCellParams<any, number>) => {

            if (params.value == null) {

                return '';
            }

            return clsx('super-app', {
                negative: parseFloat(params.value.toString()) < 0,
                positive: parseFloat(params.value.toString()) >= 0,
            });
        },
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'porcentagem_Arremessos',
        headerName: 'FGM%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'porcentagem_Lance_Livre',
        headerName: 'FTM%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'porcentagem_Tres_Pontos',
        headerName: '3P%',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        //cellClassName: 'super-app-theme--cell',
        renderCell: (params) => params.value !== null ? params.value.toFixed(2).replace(".", ",") : "0"
    },
    {
        field: 'lance_Livre_Errados',
        headerName: 'FTE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'arremessos_Errados',
        headerName: 'FGE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'tres_Pontos_Errados',
        headerName: '3PE',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 60,
        maxWidth: UtilidadeService.isMobile() ? 50 : 70,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'stocks',
        headerName: 'STOCKS',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 50 : 70,
        maxWidth: UtilidadeService.isMobile() ? 50 : 80,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
    {
        field: 'peso_Total',
        headerName: UtilidadeService.isMobile() ? "TOTAL" : 'PESO TOTAL',
        editable: false,
        headerClassName: 'super-app-theme--header',
        flex: 1,
        sortable: UtilidadeService.isMobile() ? false : true,
        minWidth: UtilidadeService.isMobile() ? 70 : 100,
        maxWidth: UtilidadeService.isMobile() ? 70 : 100,
        align: 'center',
        headerAlign: 'center',
        renderCell: (params) => params.value !== null && params.value !== undefined ? params.value.toFixed(2).replace(".", ",") : 0
    },
];

export const ListagemDeMelhoresJogadores: React.FC = () => {
    const theme = useTheme();
    //const refTab = useRef<any>(null);
    const { themeName } = useAppThemeContext();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    //const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    //const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    const [searchParams, SetSearchParams] = useSearchParams();
    const [dadosEstatisticas, setDadosEstatisticas] = useState<IDadosMelhoresJogadoresPorPosicao>();
    const [secondTimeRows, setSecondTimeRows] = useState<IDadosPontuacaoMelhoresJogadores[]>([]);
    const [firstTimeRookieRows, setFirstTimeRookieRows] = useState<IDadosPontuacaoMelhoresJogadores[]>([]);
    const [secondTimeRookieRows, setSecondTimeRookieRows] = useState<IDadosPontuacaoMelhoresJogadores[]>([]);
    const [firstTimeDpoyRows, setFirstTimeDpoyRows] = useState<IDadosPontuacaoMelhoresJogadores[]>([]);
    const [secondTimeDpoyRows, setSecondTimeDpoyRows] = useState<IDadosPontuacaoMelhoresJogadores[]>([]);
    const [premiacaoRows, setPremiacaoRows] = useState<IDadosPontuacaoMelhoresJogadores[]>([]);
    const [firstTimeRows, setFirstTimeRows] = useState<IDadosPontuacaoMelhoresJogadores[]>([]);
    const [temporadaFiltro, setTemporadaFiltro] = useState(0);
    const [qtdJogosFiltro, setQtdJogosFiltro] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });


    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadasLiga(Number(codigoLiga))
                    .then((result) => {
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;

                    });

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                        setTemporadaFiltro(liga.codigo_Temporada);
                        carregarDadosMelhoresJogadores(liga.codigo_Temporada, qtdJogosFiltro);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response !== undefined) {
                            if (errors.response.status === 401) {
                                setDadosModalMensagem({
                                    acao: true,
                                    label: "",
                                    tipo: "info",
                                    mensagem: "Sessão expirada!",
                                    display: "none",
                                    titulo: "Atenção"
                                });
                                logout();
                                setRedirecionar("0");
                                return;
                            }

                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            setRedirecionar(`/usuario/liga/${codLocal}`);
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados. Tente novamente mais tarde. Caso o problema persista, favor entrar em contato com a TI.",
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    });
            })
        }
    }, []);

    const carregarDadosMelhoresJogadores = (codigoTemporada: number, qtdJogos: number) => {
        setIsLoading(true);
        setRemoveLoading(false);

        EstatisticasService.getMelhoresJogadores(Number(codigoLiga), codigoTemporada, qtdJogos)
            .then((result) => {
                const dados = result.dado;
                setDadosEstatisticas(dados);
                setPremiacaoRows(dados.premiacao);
                setFirstTimeRows(dados.first_Time);
                setFirstTimeDpoyRows(dados.first_Time_Dpoy);
                setFirstTimeRookieRows(dados.first_Time_Rookie);
                setSecondTimeRows(dados.second_Time);
                setSecondTimeDpoyRows(dados.second_Time_Dpoy);
                setSecondTimeRookieRows(dados.second_Time_Rookie);
                setIsLoading(false);
                setRemoveLoading(true);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response) {
                    if (errors.response.status === 401) {
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }

                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados! Tente novamente mais tarde e caso o problema persista, favor entrar em contato com a TI.",
                    display: "none",
                    titulo: "Atenção"
                });

                setRedirecionar(`/usuario/liga/${codLocal}`);
                return;
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const handleSelectedTemporada = async (e: { target: { name: string; value: any; }; }) => {
        setTemporadaFiltro(e.target.value);
        //setEstatisticasRows([]);
        if (Number(e.target.value) > 0) {
            carregarDadosMelhoresJogadores(Number(e.target.value), qtdJogosFiltro);
        }
    }

    const handleQuantidadeRodadas = async (e: { target: { name: string; value: any; }; }) => {
        setQtdJogosFiltro(e.target.value);
        //setEstatisticasRows([]);
        if (Number(e.target.value) > 0) {
            carregarDadosMelhoresJogadores(temporadaFiltro, Number(e.target.value));
        }
    }

    const MyCustomNoRowsOverlay = () => (
        <Grid container size={{ xs: 12, sm: 12 }} paddingTop={2} display="flex" justifyContent="center" textAlign="center"  >
            {!removeLoading ? <Loading />
                : <Typography>Sem Registro(s)</Typography>
            }
        </Grid>
    );


    return (
        <LayoutBaseDePagina
            titulo={`Melhores Jogadores - Liga - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> Melhores Jogadores </Typography>
                                <hr />
                            </Grid>
                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" justifyContent="initial" spacing={2} paddingTop={2} paddingBottom={2}>
                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Temporadas</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={temporadaFiltro}
                                            label="Temporadas"
                                            onChange={(handleSelectedTemporada)}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            {
                                                lstTemporadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                            }

                                        </Select>
                                    </FormControl >
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3, md: 3 }} display="flex" justifyContent="center">
                                    <FormControl fullWidth disabled={isLoading}>
                                        <InputLabel id="demo-simple-select-label">Quantidade Jogos</InputLabel>
                                        <Select
                                            variant="outlined"
                                            native={false}
                                            value={qtdJogosFiltro}
                                            label="Quantidade Jogos"
                                            onChange={handleQuantidadeRodadas}
                                        >
                                            <MenuItem value={0}>Selecione</MenuItem>
                                            <MenuItem value={1}>1</MenuItem>
                                            <MenuItem value={2}>2</MenuItem>
                                            <MenuItem value={3}>3</MenuItem>
                                            <MenuItem value={4}>4</MenuItem>
                                            <MenuItem value={5}>5</MenuItem>
                                            <MenuItem value={10}>10</MenuItem>
                                            <MenuItem value={15}>15</MenuItem>
                                            <MenuItem value={20}>20</MenuItem>
                                            <MenuItem value={25}>25</MenuItem>
                                            <MenuItem value={30}>30</MenuItem>
                                            <MenuItem value={35}>35</MenuItem>
                                            <MenuItem value={40}>40</MenuItem>
                                            <MenuItem value={45}>45</MenuItem>
                                            <MenuItem value={50}>50</MenuItem>
                                            <MenuItem value={55}>55</MenuItem>
                                            <MenuItem value={60}>60</MenuItem>
                                            <MenuItem value={65}>65</MenuItem>
                                            <MenuItem value={70}>70</MenuItem>
                                            <MenuItem value={75}>75</MenuItem>
                                            <MenuItem value={80}>80</MenuItem>
                                            <MenuItem value={85}>85</MenuItem>
                                            <MenuItem value={90}>90</MenuItem>
                                            <MenuItem value={95}>95</MenuItem>


                                        </Select>
                                    </FormControl >
                                </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}>
                                {isLoading && !removeLoading && <Loading />}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {premiacaoRows.length > 0 && (
                                    <Box
                                        sx={{
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                //position: "fixed"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.tipo_Premiacao}
                                            rows={premiacaoRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 24,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                tipo_Premiacao: false,
                                                assistencias: premiacaoRows.filter(f => f.assistencias === null).length === 0,
                                                bloqueios: premiacaoRows.filter(f => (f.bloqueios === null)).length === 0,
                                                rebotes_Defensivos: premiacaoRows.filter(f => (f.rebotes_Defensivos === null)).length === 0,
                                                arremessos_Tentativas: premiacaoRows.filter(f => (f.arremessos_Tentativas === null)).length === 0,
                                                arremessos: premiacaoRows.filter(f => f.arremessos === null).length === 0,
                                                porcentagem_Arremessos: premiacaoRows.filter(f => (f.porcentagem_Arremessos === null)).length === 0,
                                                lance_Livre_Tentativas: premiacaoRows.filter(f => (f.lance_Livre_Tentativas === null)).length === 0,
                                                lance_Livre: premiacaoRows.filter(f => (f.lance_Livre === null)).length === 0,
                                                porcentagem_Lance_Livre: premiacaoRows.filter(f => (f.porcentagem_Lance_Livre === null)).length === 0,
                                                minutos: premiacaoRows.filter(f => (f.minutos === null)).length === 0,
                                                min_Plus: premiacaoRows.filter(f => (f.min_Plus === null)).length === 0,
                                                rebotes_Ofensivos: premiacaoRows.filter(f => (f.rebotes_Ofensivos === null)).length === 0,
                                                faltas: premiacaoRows.filter(f => (f.faltas === null)).length === 0,
                                                pontos: premiacaoRows.filter(f => (f.pontos === null)).length === 0,
                                                rebotes: premiacaoRows.filter(f => (f.rebotes === null)).length === 0,
                                                steal: premiacaoRows.filter(f => (f.steal === null)).length === 0,
                                                tres_Pontos_Tentativas: premiacaoRows.filter(f => (f.tres_Pontos_Tentativas === null)).length === 0,
                                                tres_Pontos: premiacaoRows.filter(f => (f.tres_Pontos === null)).length === 0,
                                                porcentagem_Tres_Pontos: premiacaoRows.filter(f => (f.porcentagem_Tres_Pontos === null)).length === 0,
                                                turnovers: premiacaoRows.filter(f => (f.turnovers === null)).length === 0,
                                                arremessos_Errados: premiacaoRows.filter(f => (f.arremessos_Errados === null || f.arremessos_Errados === undefined)).length === 0,
                                                lance_Livre_Errados: premiacaoRows.filter(f => (f.lance_Livre_Errados === null || f.lance_Livre_Errados === undefined)).length === 0,
                                                tres_Pontos_Errados: premiacaoRows.filter(f => (f.tres_Pontos_Errados === null || f.tres_Pontos_Errados === undefined)).length === 0,
                                                stocks: premiacaoRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[24, 50, 100]}
                                            disableRowSelectionOnClick
                                            hideFooter
                                            rowHeight={40}
                                            columnHeaderHeight={37}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ?11 : 14,
                                            }}

                                            slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> FIRST TIME </Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {firstTimeRows.length > 0 && (
                                    <Box
                                        sx={{
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                //position: "fixed"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.tipo_Premiacao}
                                            rows={firstTimeRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 24,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                tipo_Premiacao: false,
                                                assistencias: firstTimeRows.filter(f => f.assistencias === null).length === 0,
                                                bloqueios: firstTimeRows.filter(f => (f.bloqueios === null)).length === 0,
                                                rebotes_Defensivos: firstTimeRows.filter(f => (f.rebotes_Defensivos === null)).length === 0,
                                                arremessos_Tentativas: firstTimeRows.filter(f => (f.arremessos_Tentativas === null)).length === 0,
                                                arremessos: firstTimeRows.filter(f => f.arremessos === null).length === 0,
                                                porcentagem_Arremessos: firstTimeRows.filter(f => (f.porcentagem_Arremessos === null)).length === 0,
                                                lance_Livre_Tentativas: firstTimeRows.filter(f => (f.lance_Livre_Tentativas === null)).length === 0,
                                                lance_Livre: firstTimeRows.filter(f => (f.lance_Livre === null)).length === 0,
                                                porcentagem_Lance_Livre: firstTimeRows.filter(f => (f.porcentagem_Lance_Livre === null)).length === 0,
                                                minutos: firstTimeRows.filter(f => (f.minutos === null)).length === 0,
                                                min_Plus: firstTimeRows.filter(f => (f.min_Plus === null)).length === 0,
                                                rebotes_Ofensivos: firstTimeRows.filter(f => (f.rebotes_Ofensivos === null)).length === 0,
                                                faltas: firstTimeRows.filter(f => (f.faltas === null)).length === 0,
                                                pontos: firstTimeRows.filter(f => (f.pontos === null)).length === 0,
                                                rebotes: firstTimeRows.filter(f => (f.rebotes === null)).length === 0,
                                                steal: firstTimeRows.filter(f => (f.steal === null)).length === 0,
                                                tres_Pontos_Tentativas: firstTimeRows.filter(f => (f.tres_Pontos_Tentativas === null)).length === 0,
                                                tres_Pontos: firstTimeRows.filter(f => (f.tres_Pontos === null)).length === 0,
                                                porcentagem_Tres_Pontos: firstTimeRows.filter(f => (f.porcentagem_Tres_Pontos === null)).length === 0,
                                                turnovers: firstTimeRows.filter(f => (f.turnovers === null)).length === 0,
                                                arremessos_Errados: firstTimeRows.filter(f => (f.arremessos_Errados === null || f.arremessos_Errados === undefined)).length === 0,
                                                lance_Livre_Errados: firstTimeRows.filter(f => (f.lance_Livre_Errados === null || f.lance_Livre_Errados === undefined)).length === 0,
                                                tres_Pontos_Errados: firstTimeRows.filter(f => (f.tres_Pontos_Errados === null || f.tres_Pontos_Errados === undefined)).length === 0,
                                                stocks: firstTimeRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            hideFooter
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[24, 50, 100]}
                                            disableRowSelectionOnClick
                                            rowHeight={40}
                                            columnHeaderHeight={37}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ?11 : 14,
                                            }}


                                        />
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> SECOND TIME </Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {firstTimeRows.length > 0 && (
                                    <Box
                                        sx={{
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                //position: "fixed"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.tipo_Premiacao}
                                            rows={secondTimeRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 24,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                tipo_Premiacao: false,
                                                assistencias: firstTimeRows.filter(f => f.assistencias === null).length === 0,
                                                bloqueios: firstTimeRows.filter(f => (f.bloqueios === null)).length === 0,
                                                rebotes_Defensivos: firstTimeRows.filter(f => (f.rebotes_Defensivos === null)).length === 0,
                                                arremessos_Tentativas: firstTimeRows.filter(f => (f.arremessos_Tentativas === null)).length === 0,
                                                arremessos: firstTimeRows.filter(f => f.arremessos === null).length === 0,
                                                porcentagem_Arremessos: firstTimeRows.filter(f => (f.porcentagem_Arremessos === null)).length === 0,
                                                lance_Livre_Tentativas: firstTimeRows.filter(f => (f.lance_Livre_Tentativas === null)).length === 0,
                                                lance_Livre: firstTimeRows.filter(f => (f.lance_Livre === null)).length === 0,
                                                porcentagem_Lance_Livre: firstTimeRows.filter(f => (f.porcentagem_Lance_Livre === null)).length === 0,
                                                minutos: firstTimeRows.filter(f => (f.minutos === null)).length === 0,
                                                min_Plus: firstTimeRows.filter(f => (f.min_Plus === null)).length === 0,
                                                rebotes_Ofensivos: firstTimeRows.filter(f => (f.rebotes_Ofensivos === null)).length === 0,
                                                faltas: firstTimeRows.filter(f => (f.faltas === null)).length === 0,
                                                pontos: firstTimeRows.filter(f => (f.pontos === null)).length === 0,
                                                rebotes: firstTimeRows.filter(f => (f.rebotes === null)).length === 0,
                                                steal: firstTimeRows.filter(f => (f.steal === null)).length === 0,
                                                tres_Pontos_Tentativas: firstTimeRows.filter(f => (f.tres_Pontos_Tentativas === null)).length === 0,
                                                tres_Pontos: firstTimeRows.filter(f => (f.tres_Pontos === null)).length === 0,
                                                porcentagem_Tres_Pontos: firstTimeRows.filter(f => (f.porcentagem_Tres_Pontos === null)).length === 0,
                                                turnovers: firstTimeRows.filter(f => (f.turnovers === null)).length === 0,
                                                arremessos_Errados: firstTimeRows.filter(f => (f.arremessos_Errados === null || f.arremessos_Errados === undefined)).length === 0,
                                                lance_Livre_Errados: firstTimeRows.filter(f => (f.lance_Livre_Errados === null || f.lance_Livre_Errados === undefined)).length === 0,
                                                tres_Pontos_Errados: firstTimeRows.filter(f => (f.tres_Pontos_Errados === null || f.tres_Pontos_Errados === undefined)).length === 0,
                                                stocks: firstTimeRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            hideFooter
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[24, 50, 100]}
                                           rowHeight={40}
                                            columnHeaderHeight={37}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ?11 : 14,
                                            }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> FIRST TIME DPOY </Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {firstTimeRows.length > 0 && (
                                    <Box
                                        sx={{
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                //position: "fixed"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.tipo_Premiacao}
                                            rows={firstTimeDpoyRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 24,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                tipo_Premiacao: false,
                                                assistencias: firstTimeRows.filter(f => f.assistencias === null).length === 0,
                                                bloqueios: firstTimeRows.filter(f => (f.bloqueios === null)).length === 0,
                                                rebotes_Defensivos: firstTimeRows.filter(f => (f.rebotes_Defensivos === null)).length === 0,
                                                arremessos_Tentativas: firstTimeRows.filter(f => (f.arremessos_Tentativas === null)).length === 0,
                                                arremessos: firstTimeRows.filter(f => f.arremessos === null).length === 0,
                                                porcentagem_Arremessos: firstTimeRows.filter(f => (f.porcentagem_Arremessos === null)).length === 0,
                                                lance_Livre_Tentativas: firstTimeRows.filter(f => (f.lance_Livre_Tentativas === null)).length === 0,
                                                lance_Livre: firstTimeRows.filter(f => (f.lance_Livre === null)).length === 0,
                                                porcentagem_Lance_Livre: firstTimeRows.filter(f => (f.porcentagem_Lance_Livre === null)).length === 0,
                                                minutos: firstTimeRows.filter(f => (f.minutos === null)).length === 0,
                                                min_Plus: firstTimeRows.filter(f => (f.min_Plus === null)).length === 0,
                                                rebotes_Ofensivos: firstTimeRows.filter(f => (f.rebotes_Ofensivos === null)).length === 0,
                                                faltas: firstTimeRows.filter(f => (f.faltas === null)).length === 0,
                                                pontos: firstTimeRows.filter(f => (f.pontos === null)).length === 0,
                                                rebotes: firstTimeRows.filter(f => (f.rebotes === null)).length === 0,
                                                steal: firstTimeRows.filter(f => (f.steal === null)).length === 0,
                                                tres_Pontos_Tentativas: firstTimeRows.filter(f => (f.tres_Pontos_Tentativas === null)).length === 0,
                                                tres_Pontos: firstTimeRows.filter(f => (f.tres_Pontos === null)).length === 0,
                                                porcentagem_Tres_Pontos: firstTimeRows.filter(f => (f.porcentagem_Tres_Pontos === null)).length === 0,
                                                turnovers: firstTimeRows.filter(f => (f.turnovers === null)).length === 0,
                                                arremessos_Errados: firstTimeRows.filter(f => (f.arremessos_Errados === null || f.arremessos_Errados === undefined)).length === 0,
                                                lance_Livre_Errados: firstTimeRows.filter(f => (f.lance_Livre_Errados === null || f.lance_Livre_Errados === undefined)).length === 0,
                                                tres_Pontos_Errados: firstTimeRows.filter(f => (f.tres_Pontos_Errados === null || f.tres_Pontos_Errados === undefined)).length === 0,
                                                stocks: firstTimeRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            hideFooter
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[24, 50, 100]}
                                            disableRowSelectionOnClick
                                            rowHeight={40}
                                            columnHeaderHeight={37}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ?11 : 14,
                                            }}
                                            slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> SECOND TIME DPOY </Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {firstTimeRows.length > 0 && (
                                    <Box
                                        sx={{
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                //position: "fixed"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.tipo_Premiacao}
                                            rows={secondTimeDpoyRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 24,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                tipo_Premiacao: false,
                                                assistencias: firstTimeRows.filter(f => f.assistencias === null).length === 0,
                                                bloqueios: firstTimeRows.filter(f => (f.bloqueios === null)).length === 0,
                                                rebotes_Defensivos: firstTimeRows.filter(f => (f.rebotes_Defensivos === null)).length === 0,
                                                arremessos_Tentativas: firstTimeRows.filter(f => (f.arremessos_Tentativas === null)).length === 0,
                                                arremessos: firstTimeRows.filter(f => f.arremessos === null).length === 0,
                                                porcentagem_Arremessos: firstTimeRows.filter(f => (f.porcentagem_Arremessos === null)).length === 0,
                                                lance_Livre_Tentativas: firstTimeRows.filter(f => (f.lance_Livre_Tentativas === null)).length === 0,
                                                lance_Livre: firstTimeRows.filter(f => (f.lance_Livre === null)).length === 0,
                                                porcentagem_Lance_Livre: firstTimeRows.filter(f => (f.porcentagem_Lance_Livre === null)).length === 0,
                                                minutos: firstTimeRows.filter(f => (f.minutos === null)).length === 0,
                                                min_Plus: firstTimeRows.filter(f => (f.min_Plus === null)).length === 0,
                                                rebotes_Ofensivos: firstTimeRows.filter(f => (f.rebotes_Ofensivos === null)).length === 0,
                                                faltas: firstTimeRows.filter(f => (f.faltas === null)).length === 0,
                                                pontos: firstTimeRows.filter(f => (f.pontos === null)).length === 0,
                                                rebotes: firstTimeRows.filter(f => (f.rebotes === null)).length === 0,
                                                steal: firstTimeRows.filter(f => (f.steal === null)).length === 0,
                                                tres_Pontos_Tentativas: firstTimeRows.filter(f => (f.tres_Pontos_Tentativas === null)).length === 0,
                                                tres_Pontos: firstTimeRows.filter(f => (f.tres_Pontos === null)).length === 0,
                                                porcentagem_Tres_Pontos: firstTimeRows.filter(f => (f.porcentagem_Tres_Pontos === null)).length === 0,
                                                turnovers: firstTimeRows.filter(f => (f.turnovers === null)).length === 0,
                                                arremessos_Errados: firstTimeRows.filter(f => (f.arremessos_Errados === null || f.arremessos_Errados === undefined)).length === 0,
                                                lance_Livre_Errados: firstTimeRows.filter(f => (f.lance_Livre_Errados === null || f.lance_Livre_Errados === undefined)).length === 0,
                                                tres_Pontos_Errados: firstTimeRows.filter(f => (f.tres_Pontos_Errados === null || f.tres_Pontos_Errados === undefined)).length === 0,
                                                stocks: firstTimeRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            hideFooter
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[24, 50, 100]}
                                            disableRowSelectionOnClick
                                            rowHeight={40}
                                            columnHeaderHeight={37}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ?11 : 14,
                                            }}
                                            slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> FIRST TIME ROOKIE  </Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {firstTimeRows.length > 0 && (
                                    <Box
                                        sx={{
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                //position: "fixed"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.tipo_Premiacao}
                                            rows={firstTimeRookieRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 24,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                tipo_Premiacao: false,
                                                assistencias: firstTimeRows.filter(f => f.assistencias === null).length === 0,
                                                bloqueios: firstTimeRows.filter(f => (f.bloqueios === null)).length === 0,
                                                rebotes_Defensivos: firstTimeRows.filter(f => (f.rebotes_Defensivos === null)).length === 0,
                                                arremessos_Tentativas: firstTimeRows.filter(f => (f.arremessos_Tentativas === null)).length === 0,
                                                arremessos: firstTimeRows.filter(f => f.arremessos === null).length === 0,
                                                porcentagem_Arremessos: firstTimeRows.filter(f => (f.porcentagem_Arremessos === null)).length === 0,
                                                lance_Livre_Tentativas: firstTimeRows.filter(f => (f.lance_Livre_Tentativas === null)).length === 0,
                                                lance_Livre: firstTimeRows.filter(f => (f.lance_Livre === null)).length === 0,
                                                porcentagem_Lance_Livre: firstTimeRows.filter(f => (f.porcentagem_Lance_Livre === null)).length === 0,
                                                minutos: firstTimeRows.filter(f => (f.minutos === null)).length === 0,
                                                min_Plus: firstTimeRows.filter(f => (f.min_Plus === null)).length === 0,
                                                rebotes_Ofensivos: firstTimeRows.filter(f => (f.rebotes_Ofensivos === null)).length === 0,
                                                faltas: firstTimeRows.filter(f => (f.faltas === null)).length === 0,
                                                pontos: firstTimeRows.filter(f => (f.pontos === null)).length === 0,
                                                rebotes: firstTimeRows.filter(f => (f.rebotes === null)).length === 0,
                                                steal: firstTimeRows.filter(f => (f.steal === null)).length === 0,
                                                tres_Pontos_Tentativas: firstTimeRows.filter(f => (f.tres_Pontos_Tentativas === null)).length === 0,
                                                tres_Pontos: firstTimeRows.filter(f => (f.tres_Pontos === null)).length === 0,
                                                porcentagem_Tres_Pontos: firstTimeRows.filter(f => (f.porcentagem_Tres_Pontos === null)).length === 0,
                                                turnovers: firstTimeRows.filter(f => (f.turnovers === null)).length === 0,
                                                arremessos_Errados: firstTimeRows.filter(f => (f.arremessos_Errados === null || f.arremessos_Errados === undefined)).length === 0,
                                                lance_Livre_Errados: firstTimeRows.filter(f => (f.lance_Livre_Errados === null || f.lance_Livre_Errados === undefined)).length === 0,
                                                tres_Pontos_Errados: firstTimeRows.filter(f => (f.tres_Pontos_Errados === null || f.tres_Pontos_Errados === undefined)).length === 0,
                                                stocks: firstTimeRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            hideFooter
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[24, 50, 100]}
                                            disableRowSelectionOnClick
                                            rowHeight={40}
                                            columnHeaderHeight={37}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ?11 : 14,
                                            }}
                                            slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}

                                        />
                                    </Box>
                                )}
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6"> SECOND TIME ROOKIE  </Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {firstTimeRows.length > 0 && (
                                    <Box
                                        sx={{
                                            height: 'auto', backgroundColor: themeName === "light" ? "#cfcfcd" : "auto", fontWeight: 'bold',
                                            '& .super-app-theme--header': {
                                                backgroundColor: theme.palette.common.black,
                                                color: theme.palette.common.white,
                                                //position: "fixed"
                                            },
                                            '& .super-app.negative': {
                                                color: 'red',
                                                fontWeight: 'bold'
                                            },
                                            '& .super-app.positive': {
                                                color: "#00e676", /// themeName === "light" ? "black" : "auto",
                                                fontWeight: '600',
                                            },
                                            '& .super-app-theme--cell': {
                                                color: '#00e676',
                                                fontWeight: '600',
                                            },
                                            '& .MuiDataGrid-main': {
                                                height: UtilidadeService.isMobile() ? "280px" : "maxValor",
                                                overflow: UtilidadeService.isMobile() ? "overlay" : "hidden",
                                            },
                                            '& .MuiDataGrid-columnHeaders ': {
                                                //position: UtilidadeService.isMobile() ? "fixed" : "relative",
                                                zIndex: UtilidadeService.isMobile() ? 999 : "auto",
                                            }
                                        }}>
                                        <DataGrid
                                            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
                                            getRowId={(r) => r.tipo_Premiacao}
                                            rows={secondTimeRookieRows}
                                            columns={columnsGeral}
                                            initialState={{
                                                pagination: {
                                                    paginationModel: {
                                                        pageSize: 24,
                                                    },
                                                },
                                            }}
                                            columnVisibilityModel={{
                                                tipo_Premiacao: false,
                                                assistencias: firstTimeRows.filter(f => f.assistencias === null).length === 0,
                                                bloqueios: firstTimeRows.filter(f => (f.bloqueios === null)).length === 0,
                                                rebotes_Defensivos: firstTimeRows.filter(f => (f.rebotes_Defensivos === null)).length === 0,
                                                arremessos_Tentativas: firstTimeRows.filter(f => (f.arremessos_Tentativas === null)).length === 0,
                                                arremessos: firstTimeRows.filter(f => f.arremessos === null).length === 0,
                                                porcentagem_Arremessos: firstTimeRows.filter(f => (f.porcentagem_Arremessos === null)).length === 0,
                                                lance_Livre_Tentativas: firstTimeRows.filter(f => (f.lance_Livre_Tentativas === null)).length === 0,
                                                lance_Livre: firstTimeRows.filter(f => (f.lance_Livre === null)).length === 0,
                                                porcentagem_Lance_Livre: firstTimeRows.filter(f => (f.porcentagem_Lance_Livre === null)).length === 0,
                                                minutos: firstTimeRows.filter(f => (f.minutos === null)).length === 0,
                                                min_Plus: firstTimeRows.filter(f => (f.min_Plus === null)).length === 0,
                                                rebotes_Ofensivos: firstTimeRows.filter(f => (f.rebotes_Ofensivos === null)).length === 0,
                                                faltas: firstTimeRows.filter(f => (f.faltas === null)).length === 0,
                                                pontos: firstTimeRows.filter(f => (f.pontos === null)).length === 0,
                                                rebotes: firstTimeRows.filter(f => (f.rebotes === null)).length === 0,
                                                steal: firstTimeRows.filter(f => (f.steal === null)).length === 0,
                                                tres_Pontos_Tentativas: firstTimeRows.filter(f => (f.tres_Pontos_Tentativas === null)).length === 0,
                                                tres_Pontos: firstTimeRows.filter(f => (f.tres_Pontos === null)).length === 0,
                                                porcentagem_Tres_Pontos: firstTimeRows.filter(f => (f.porcentagem_Tres_Pontos === null)).length === 0,
                                                turnovers: firstTimeRows.filter(f => (f.turnovers === null)).length === 0,
                                                arremessos_Errados: firstTimeRows.filter(f => (f.arremessos_Errados === null || f.arremessos_Errados === undefined)).length === 0,
                                                lance_Livre_Errados: firstTimeRows.filter(f => (f.lance_Livre_Errados === null || f.lance_Livre_Errados === undefined)).length === 0,
                                                tres_Pontos_Errados: firstTimeRows.filter(f => (f.tres_Pontos_Errados === null || f.tres_Pontos_Errados === undefined)).length === 0,
                                                stocks: firstTimeRows.filter(f => (f.stocks === null || f.stocks === undefined)).length === 0,
                                            }}
                                            disableDensitySelector
                                            disableVirtualization
                                            hideFooter
                                            disableColumnMenu={UtilidadeService.isMobile() ? true : false}
                                            pageSizeOptions={[24, 50, 100]}
                                            disableRowSelectionOnClick
                                            rowHeight={40}
                                            columnHeaderHeight={37}
                                            sx={{
                                                fontSize: UtilidadeService.isMobile() ?11 : 14,
                                            }}
                                            slots={{ noRowsOverlay: MyCustomNoRowsOverlay }}
                                        />
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}


